<template>           
  <v-card>    
    <v-card-text class="pt-0" style="overflow-x: auto; position:relative" v-if="fm.jalur_id==2">
      <h3 class="text-xs-left mt-4">Khusus jalur prestasi, ananda wajib mengisi kolom prestasi dibawah, klik icon plus (+) untuk menambah data :</h3> 
      <div class="v-table__overflow tabular">
        <v-btn @click="newPrestasi()" icon class="primary mb-2" style="position: absolute; right:15px; " ><v-icon>add</v-icon></v-btn>                                           
        <v-data-table
          v-bind:headers="prestasi.headers"
          v-bind:items="fm.calonPrestasis"
          hide-actions class="elevation-1" 
        >
          <template slot="items" slot-scope="props">
            <td align="vertical" style="width:1%;">{{props.index+1}}</td>
            <td style="min-width:180px; width:180px">
              <v-select
                solo hide-details  
                v-bind:items="prestasi.types[fm.tingkat_id]"
                v-model="props.item.type"
                label="Kategori"    
                item-text="name"
                item-value="id"  
                class="mb-1"
              ></v-select>                            
            </td> 
            <td align="vertical" style="min-width:120px; width:120px">
              <v-select
                solo hide-details  
                v-bind:items="prestasi.tingkats"
                v-model="props.item.tingkat"
                label="Tingkat"   
                class="mb-1"                   
              ></v-select>                            
            </td>              
            <td align="vertical" style="min-width:100px; width:100px">
              <v-select
                solo hide-details  
                v-bind:items="prestasi.juaras"
                v-model="props.item.nama"
                label="Juara"   
                class="mb-1"                   
              ></v-select>                            
            </td>  
            <td align="vertical" style="min-width:250px; ">
              <v-text-field
                solo hide-details
                type="text"
                v-model="props.item.description"
                label="(exp : Juara 1 OSN Cab.Matematika Tingkat Nasional)"      
                style="with:250px"  
                class="mb-1"                            
              ></v-text-field>                            
            </td>
            <td align="vertical" style="width:200px">
              <v-layout row>
              <a :href="props.item.image" target="_blank"><img :src="props.item.thumb" style="height:40px" class="mr-3" /></a>
              <input
                solo hide-details
                type="file"                       
                label="file"                     
                v-on:change="setFile($event, props)"
                style="with:230px" 
                accept="image/jpeg,image/jpg,image/png"  
                class="mb-1"                          
              />                            
              </v-layout>
            </td>
            <td align="vertical" style="width:1%">                                    
              <v-btn v-on:click="delPrestasi(props)" icon class="pink--text" small>
                <v-icon>delete</v-icon>
              </v-btn>
            </td>   
          </template>  
        </v-data-table>
      </div>  
      <v-alert type="error" :value="true" v-if="prestasiError">
        {{prestasiError}}
      </v-alert>        
    </v-card-text>     
    <v-card-text>      
      <strong>Upload Foto Ananda dengan mengklik icon camera : </strong><br/>
      <p>Syarat dan ketentuan Foto :
        <ul>
          <li>Baju ananda harus formal, khusus putri wajib menggunakan jilbab.</li>
          <li>Posisi Bahu dan Dagu Tegak mengahadap kedepan</li>
          <li>Pose foto formal seperti saat membuat pas foto</li>
          <li>Wajah harus memenuhi setidaknya 1/3 dari frame foto</li>
        </ul>
      </p>
      <!--<h1 class="display-3 ml-4 text-xs-left white--text">{{getTingkat(fm.tingkat_id)}} :class="getColor(fm.tingkat_id)"</h1>-->
      <div style="width:100%; text-align:center; position:relative">
        
        <div v-if="fm.user_id" class="v-avatar" style="max-height:200px; border:0px solid #aaa; position:relative;" >                        
          <img @click="cropshow=true" class="elevation-4" :src="imgUrl ? imgUrl : require('@/assets/img/avatar.png')" style="max-width:100%; max-height:200px;" />
          <v-progress-circular
            style="position:absolute; left:5px; top:10px"
            v-if="imgLoading"
            :size="190"
            :width="12"
            color="info"
            indeterminate                  
          ></v-progress-circular>  
          <v-btn @click="cropshow=true" fab absolute dark small bottom style="cursor:pointer; position:absolute; right:0; top:0" class="blue"><v-icon>camera_alt</v-icon></v-btn>              
        </div>  
      </div>                  
    </v-card-text>      
    <v-card-text class="pa-3" style="overflow: auto">
      <span>Isi form data berikut dengan seksama : </span><br/><br/>
      <v-container grid-list-lg fluid class="pa-0 ma-0">
        <v-layout row wrap>
          <v-flex xs12 lg4 md4 sm6>
            <h3 class="text-xs-left white--text lighten-1 pa-2" :class="getColor(fm.tingkat_id)">Data Siswa</h3>
            <v-divider :class="getColor(fm.tingkat_id)" />
            <!--<v-radio-group :disabled="true" label="mendaftar * :" v-model="fm.tingkat_id" row v-validate="'required'" data-vv-name="tingkat_id" :error-messages="errors.collect('tingkat_id')">
              <v-radio label="SD"  :value="1"></v-radio>
              <v-radio label="SMP" :value="2"></v-radio>
              <v-radio label="MA" :value="3"></v-radio>              
            </v-radio-group>-->
            <div class="my-4">
              <span>Mendaftar * :</span><br/>
              <input type="radio" :disabled="true" v-model="fm.tingkat_id" :value="1" /> SD &nbsp;&nbsp;
              <input type="radio" :disabled="true" v-model="fm.tingkat_id" :value="2" /> SMP &nbsp;&nbsp;
              <input type="radio" :disabled="true" v-model="fm.tingkat_id" :value="3" /> MA &nbsp;&nbsp;
            </div>
            <!--<div class="mb-4" v-if="fm.tingkat_id === 3">
              <span>Jurusan * :</span><br/>
              <input type="radio" v-model="fm.jurusan_id" required :value="4" /> IPA &nbsp;&nbsp;
              <input type="radio" v-model="fm.jurusan_id" required :value="5" /> IPS &nbsp;&nbsp;
              <input type="radio" v-model="fm.jurusan_id" required :value="6" /> AGAMA &nbsp;&nbsp;
            </div>
            -->
            <v-radio-group label="Jurusan * :" class="mb-3" v-model="fm.jurusan_id" row  v-if="fm.tingkat_id === 3" v-validate="'required'" data-vv-name="jurusan_id" :error-messages="errors.collect('jurusan_id')">
              <v-radio label="IPA"  :value="4"></v-radio>
              <v-radio label="IPS" :value="5"></v-radio>
              <v-radio label="AGAMA" :value="6"></v-radio>
            </v-radio-group>
            
            <v-text-field box
              append-icon="person" 
              label="nama siswa *" 
              type="text" 
              v-model="fm.nama"                    
              data-vv-name="nama"
              v-validate="'required'"
              @keyup="fm.nama = fm.nama.toUpperCase()"
              :error-messages="errors.collect('nama')"                      
            ></v-text-field>     
            <v-layout row wrap>
              <v-flex xs5>
                <v-text-field box
                  label="tempat lahir*" 
                  type="text" 
                  v-model="fm.lahir_tempat"                    
                  data-vv-name="lahir_tempat"     
                  v-validate="'required'"
                  @keyup="fm.lahir_tempat = fm.lahir_tempat.toUpperCase()"
                  :error-messages="errors.collect('lahir_tempat')"                      
                ></v-text-field>  
              </v-flex>
              <v-flex xs7>
                 <v-text-field
                    type="date"
                    box
                    slot="activator"
                    label="tanggal lahir*"
                    v-model="fm.lahir_tanggal"
                    data-vv-name="lahir_tanggal"
                    v-validate="'required'"
                    :error-messages="errors.collect('lahir_tanggal')"
                  ></v-text-field>
                <!--<v-menu                                 
                  ref="birthdate" lazy
                  v-bind:close-on-content-click="false"                        
                  transition="scale-transition"
                  offset-y full-width
                  v-bind:nudge-bottom="-22"
                  max-width="290px"
                  v-bind:return-value.sync="fm.lahir_tanggal"                        
                >
                  <v-text-field
                    clearable box
                    slot="activator"
                    label="tanggal lahir*"
                    v-model="fm.lahir_tanggalV"
                    append-icon="event"
                    readonly             
                    data-vv-name="lahir_tanggal"
                    v-validate="'required'"
                    :error-messages="errors.collect('lahir_tanggal')"
                  ></v-text-field>
                  <v-date-picker v-model="fm.lahir_tanggal" no-title scrollable>                                      
                  </v-date-picker>
                </v-menu>-->
              </v-flex>
            </v-layout>   
            <!--<v-radio-group label="gender*:" v-model="fm.gender" row
              data-vv-name="gender" v-validate="'required'"    
              :error-messages="errors.collect('gender')">
              <v-radio label="L" :value="1"></v-radio>
              <v-radio label="P" :value="2"></v-radio>            
            </v-radio-group>     -->
            <div class="mb-4">
              <span>Gender * :</span><br/>
              <input type="radio" v-model="fm.gender" :value="1" /> Laki-laki &nbsp;&nbsp;
              <input type="radio" v-model="fm.gender" :value="2" /> Perempuan &nbsp;&nbsp;              
            </div>
            <v-text-field box
              append-icon="home" 
              label="alamat*" 
              type="text" 
              v-model="fm.alamat"   
              @keyup="fm.alamat = fm.alamat.toUpperCase()"             
              data-vv-name="alamat"   
              v-validate="'required'"
              :error-messages="errors.collect('alamat')"                  
            ></v-text-field> 
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete box
                  v-bind:items="provinsis"
                  v-bind:filter="customFilter"     
                  v-bind:search-input.sync="provinsiSearch"
                  item-text="nama"
                  item-value="id"
                  v-model="fm.provinsi_id"
                  label="provinsi*"
                  hide-no-data 
                  v-validate="'required'"
                  data-vv-name="provinsi_id"     
                  :error-messages="errors.collect('provinsi_id')"
                  :loading="provinsiLoading" 
                  autocomplete="off"               
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete box
                  v-bind:items="kotas"
                  v-bind:filter="customFilter"     
                  v-bind:search-input.sync="kotaSearch"
                  item-text="nama"
                  item-value="id"
                  v-model="fm.kota_id"
                  label="kota*"
                  hide-no-data 
                  data-vv-name="kota_id"
                  v-validate="'required'"
                  :error-messages="errors.collect('kota_id')"
                  :loading="kotaLoading"
                  autocomplete="off"    
                ></v-autocomplete>
              </v-flex>
            </v-layout>    
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete box
                  v-bind:items="kecamatans"
                  v-bind:filter="customFilter"     
                  v-bind:search-input.sync="kecamatanSearch"
                  item-text="nama"
                  item-value="id"
                  v-model="fm.kecamatan_id"
                  label="kecamatan*"
                  hide-no-data 
                  data-vv-name="kecamatan_id"
                  v-validate="'required'"
                  :error-messages="errors.collect('kecamatan_id')"
                  :loading="kecamatanLoading"
                  autocomplete="off"    
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete box
                  v-bind:items="kelurahans"
                  v-bind:filter="customFilter"     
                  v-bind:search-input.sync="kelurahanSearch"
                  item-text="nama"
                  item-value="id"
                  v-model="fm.kelurahan_id"
                  label="kelurahan*"
                  hide-no-data 
                  data-vv-name="kelurahan_id"  
                  v-validate="'required'"
                  :error-messages="errors.collect('kelurahan_id')"
                  :loading="kelurahanLoading"
                  autocomplete="off"    
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
              </v-flex>
              <v-flex xs6>
              </v-flex>
            </v-layout>    
          </v-flex>              
          <v-flex lg4 md4 sm2 xs12>
            <h3 class="text-xs-left pa-2 blue white--text">Sekolah Asal</h3> 
            <v-divider class="blue mb-3" />    
            <v-checkbox :disabled="fm.jalur_id != 3" v-if="fm.gender  && fm.jalur_id == 3"
              v-model="fm.sekolah_internal"
              :true-value="true"
              :false-value="false"
              :label="internal_label"
            ></v-checkbox>
            <v-text-field box
              append-icon="domain" 
              :label="fm.tingkat_id===1?'nama sekolah':'nama sekolah*'" 
              type="text" 
              v-model="fm.sekolah_nama" 
              @keyup="fm.sekolah_nama = fm.sekolah_nama.toUpperCase()"
              :disabled="fm.sekolah_internal"                           
            ></v-text-field>        
            <p class="pt-3" v-if="!fm.sekolah_internal">
              untuk mengetahui NPSN dan standarisasi nama sekolah klik link berikut : <a href="https://dapo.kemdikbud.go.id/pencarian" target="_blank">https://dapo.kemdikbud.go.id/pencarian</a>
            </p>   
            <v-layout row wrap style="border:0px solid #eee;">    
              <v-flex xs12>
                 <v-text-field box
                  append-icon="domain" 
                  :label="fm.tingkat_id===1?'NPSN sekolah':'NPSN sekolah*'" 
                  type="text" 
                  v-model="fm.sekolah_npsn"   
                  :disabled="fm.sekolah_internal"             
                ></v-text-field>
              </v-flex>
            </v-layout>
            <p class="pt-2">
              Jika belum mengetahui NISN ananda klik link berikut : <a href="https://nisn.data.kemdikbud.go.id/index.php/Cindex/formcaribynama" target="_blank">https://nisn.data.kemdikbud.go.id/index.php/Cindex/formcaribynama</a>
            </p> 
            <v-text-field box
              append-icon="fingerprint" 
              :label="fm.tingkat_id===1?'NIS':'NISN'" 
              type="text" 
              v-model="fm.sekolah_nis"                
            ></v-text-field>  
            <v-layout row wrap> 
              <v-flex xs6>
                <v-autocomplete box
                  v-bind:items="provinsis"
                  v-bind:filter="customFilter"     
                  v-bind:search-input.sync="sekolahProvinsiSearch"
                  item-text="nama"
                  item-value="id"
                  v-model="fm.sekolah_provinsi_id"
                  :label="fm.tingkat_id===1?'provinsi':'provinsi*'"
                  hide-no-data 
                  :loading="sekolahProvinsiLoading"
                  :disabled="fm.sekolah_internal"
                  autocomplete="off"    
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete box
                  v-bind:items="sekolahKotas"
                  v-bind:filter="customFilter"     
                  v-bind:search-input.sync="sekolahKotaSearch"
                  item-text="nama"
                  item-value="id"
                  v-model="fm.sekolah_kota_id"
                  :label="fm.tingkat_id===1?'kota':'kota*'"
                  hide-no-data 
                  :loading="sekolahKotaLoading"
                  :disabled="fm.sekolah_internal"
                  autocomplete="off"    
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete box
                  v-bind:items="sekolahKecamatans"
                  v-bind:filter="customFilter"     
                  v-bind:search-input.sync="sekolahKecamatanSearch"
                  item-text="nama"
                  item-value="id"
                  v-model="fm.sekolah_kecamatan_id"
                  :label="fm.tingkat_id===1?'kecamatan':'kecamatan*'"
                  hide-no-data 
                  :loading="sekolahKecamatanLoading"
                  :disabled="fm.sekolah_internal"
                  autocomplete="off"    
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg4 md4 sm2 xs12>
            <h3 class="text-xs-left pa-2 orange white--text">Data Orang Tua</h3> 
            <v-divider class="orange mb-3" />   
             <v-text-field box
              append-icon="email" 
              label="email*" 
              type="text" 
              v-model="fm.email"
              data-vv-name="email"     
              v-validate="'required'"
              :error-messages="errors.collect('email')"                 
            ></v-text-field>      
            <v-layout row wrap>              
              <v-flex xs6>
                <v-text-field box
                  append-icon="phone" 
                  label="telepon/hp*" 
                  type="number" 
                  v-model="fm.telepon"
                  data-vv-name="telepon"    
                  v-validate="'required'"
                  :error-messages="errors.collect('telepon')"                  
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                 <v-text-field box
                  append-icon="phone" 
                  label="No WA(whatsapp)*" 
                  type="number" 
                  v-model="fm.whatsapp"               
                  data-vv-name="whatsapp"    
                  v-validate="'required'"
                  :error-messages="errors.collect('whatsapp')"                  
                ></v-text-field>
              </v-flex>     
            </v-layout>
            <v-text-field box
              append-icon="face" 
              label="Nama Ayah*" 
              type="text" 
              v-model="fm.ayah_nama"
              @keyup="fm.ayah_nama = fm.ayah_nama.toUpperCase()"
              data-vv-name="ayah_nama"
              v-validate="'required'"
              :error-messages="errors.collect('ayah_nama')"                      
            ></v-text-field>
            <v-layout row wrap>
              <v-flex xs6>
                <v-select box
                  :items="pekerjaans"
                  v-model="fm.ayah_pekerjaan"
                  label="Pekerjaan Ayah*"
                  data-vv-name="ayah_pekerjaan"    
                  v-validate="'required'"
                  :error-messages="errors.collect('ayah_pekerjaan')"                      
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-select box
                  :items="penghasilans"
                  v-model="fm.ayah_penghasilan"
                  label="Penghasilan Ayah*"
                  data-vv-name="ayah_penghasilan"   
                  v-validate="'required'"
                  :error-messages="errors.collect('ayah_penghasilan')"                     
                ></v-select>
              </v-flex>
            </v-layout>
            <v-text-field box
              append-icon="face" 
              label="Nama Ibu*" 
              type="text" 
              v-model="fm.ibu_nama"
              @keyup="fm.ibu_nama = fm.ibu_nama.toUpperCase()"
              data-vv-name="ibu_nama"     
              v-validate="'required'"
              :error-messages="errors.collect('ibu_nama')"                      
            ></v-text-field>
            <v-layout row wrap>
              <v-flex xs6>
                <v-select box
                  :items="pekerjaans"
                  v-model="fm.ibu_pekerjaan"
                  label="Pekerjaan Ibu*"
                  data-vv-name="ibu_pekerjaan"   
                  v-validate="'required'"
                  :error-messages="errors.collect('ibu_pekerjaan')"                      
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-select box
                  :items="penghasilans"
                  v-model="fm.ibu_penghasilan"
                  label="Penghasilan Ibu*"                    
                  data-vv-name="ibu_penghasilan"
                  v-validate="'required'"
                  :error-messages="errors.collect('ibu_penghasilan')"                      
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-select box
                  :items="penghasilans"
                  v-model="fm.pengeluaran"
                  label="Pengeluaran Keluarga/Bulan*"
                  data-vv-name="pengeluaran"     
                  v-validate="'required'"
                  :error-messages="errors.collect('pengeluaran')"                  
                ></v-select> 
              </v-flex>
            </v-layout>    
                                            
          </v-flex>
        </v-layout>          
      </v-container>
      <crop-upload style="width:100%;" field="img"
        @crop-success="cropSuccess"        
          :width="300"
          :height="300"         
          lang-type="en"
          :value.sync="cropshow"
          v-model="cropshow"                
          img-format="png">            
      </crop-upload> 
    </v-card-text>
    <!--<v-card-text style="overflow-x: auto; position:relative" v-if="fm.jalur_id==1">
      <h3 class="text-xs-left mt-4">Prestasi Siswa (jika ada)</h3>          
      <div class="v-table__overflow tabular">
        <v-btn @click="newPrestasi()" icon class="primary--text mb-2" style="position: absolute; right:15px; " ><v-icon>add</v-icon></v-btn>                                           
        <v-data-table
          v-bind:headers="prestasi.headers"
          v-bind:items="fm.calonPrestasis"
          hide-actions class="elevation-1" 
        >
          <template slot="items" slot-scope="props" >
            <td style="width:1%">{{props.index+1}}</td>
            <td style="width:180px">
              <v-select
                solo hide-details  
                v-bind:items="prestasi.types"
                v-model="props.item.type"
                label="Kategori"    
                item-text="name"
                item-value="id"  
              ></v-select>                            
            </td>  
            <td style="width:100px">
              <v-select
                solo hide-details  
                v-bind:items="prestasi.juaras"
                v-model="props.item.nama"
                label="Juara"                      
              ></v-select>                            
            </td>  
            <td style="min-width:200px">
              <v-text-field
                solo hide-details
                type="text"
                v-model="props.item.description"
                label="(exp : Juara 1 OSN Cab.Matematika Tingkat Nasional)"      
                style="with:250px"                              
              ></v-text-field>                            
            </td>
            <td style="width:250px">
              <v-layout row>
              <a :href="props.item.image" target="_blank"><img :src="props.item.thumb" style="height:40px" class="mr-3" /></a>
              <input
                solo hide-details
                type="file"                       
                label="file"                     
                v-on:change="setFile($event, props)"
                style="with:230px" 
                accept="image/*"                            
              />            
              </v-layout>                
            </td>
            <td style="width:1%">                                    
              <v-btn v-on:click="delPrestasi(props)" icon class="pink--text" small>
                <v-icon>delete</v-icon>
              </v-btn>
            </td>   
          </template>  
        </v-data-table>
      </div>          
    </v-card-text>-->
    <v-card-actions class="pa-4">
      <span>(*) required</span>                  
      <v-spacer></v-spacer>
      <v-btn class="blue ml-4" :loading="saveLoading" @click="saveAdministrasi()" dark>Save</v-btn>
      <v-btn class="indigo" :loading="completeLoading" @click="completeAdministrasi()" dark>Complete</v-btn>
    </v-card-actions>
  </v-card>    
</template>
<script>
import CropUpload from 'vue-image-crop-upload';
import User   from '@/util/models/User';
import Model  from '@/models/dashboard';

const  model = new Model();

export default {
  $_veeValidate: {validator: 'new'},  
  name:'step2',  
  components: { 
    CropUpload
  },
  props:{
    stepke:{
      type: Number,
      default: null,
    },
    tingkat_id:{
      type: Number,
      default: null,
    },
    jalur_id:{
      type: Number,
      default: null,
    },
    voucher:{
      type: String,
      default: null,
    }
  },
  data:()=>({    
    stepkeLocal : null,
    cropshow: false,
    user : User.attributes(),
    imgUrl : null,
    imgLoading : false,
    saveLoading : false,
    completeLoading : false, 
    is_prestasi : false,
    prestasi  : {
        types:{
          2:[
            {id:1, name:'OSN'},
            {id:2, name:'KSM'},
            {id:3, name:'KSN'},
            {id:4, name:'MHQ'},
            {id:5, name:'Hafidz >10 juz'}           
          ],
          3:[
            {id:1, name:'OSN'},
            {id:2, name:'KSM'},
            {id:3, name:'KSN'},
            {id:4, name:'MHQ'},
            {id:5, name:'Hafidz >20 juz'}            
          ]
        },
        juaras :['1','2','3', 'lainnya'],
        tingkats :['Nasional','Provinsi', 'Tes langsung'],
        headers: [            
          { text: 'No', value:'no'},
          { text: 'Kategori', value: 'type'},
          { text: 'Tingkat', value: 'tingkat'},
          { text: 'Juara', value: 'nama'},
          { text: 'Deskripsi', value: 'description'},              
          { text: 'Foto Sertifikat (jpg/png)', value:''},
          { text: '', value: '', align:'center', sortable:false },              
        ],          
    }, 
    fm : {
      user_id : null,
      tingkat_id : null,
      jalur_id :null ,
      jurusan_id : null,
      nama : null,
      gender : null,
      lahir_tempat : null,
      lahir_tanggal : null,
      lahir_tanggalV : null,
      alamat : null,
      kelurahan_id : null,
      kecamatan_id : null,
      kota_id : null,
      provinsi_id : null,
      prestasi_osn : null,
      prestasi_mtq : null,
      prestasi_hafidz : null,
      prestasi_other : null,
      sekolah_internal : null,
      sekolah_nama : null,
      sekolah_npsn : null,
      sekolah_nis : null,
      sekolah_provinsi_id : null,
      sekolah_kota_id : null,
      sekolah_kecamatan_id : null,
      telepon : null,
      whatsapp : null,
      email : null,
      ayah_nama : null,
      ayah_pekerjaan : null, 
      ayah_jabatan : null,
      ayah_penghasilan : null,
      ibu_nama : null,
      ibu_pekerjaan : null, 
      ibu_jabatan : null,
      ibu_penghasilan : null,
      voucher:null,
      calonPrestasis : [],       
    },
    prestasiError:'',
    provinsis : [],
    provinsiLoading : false,
    provinsiSearch : null,
    kotaLoading : false,
    kotas : [],   
    kotaSearch : null,
    kecamatanLoading : false,
    kecamatans : [],
    kecamatanSearch : null,
    kelurahanLoading : false,
    kelurahans : [],
    kelurahanSearch : null,
    sekolahProvinsiLoading : false,
    sekolahProvinsis : [],
    sekolahProvinsiSearch : null,
    sekolahKotaLoading : false,        
    sekolahKotas : [],
    sekolahKotaSearch : null,
    sekolahKecamatanLoading : false,
    sekolahKecamatans : [],
    sekolahKecamatanSearch : null,
    pekerjaans : [],
    penghasilans : [],
    internal_label: '',
  }),
  watch:{
    stepke(newStep){this.stepkeLocal = newStep},
    stepkeLocal(newStep){this.$emit('update:stepke', newStep)},
    'fm.tingkat_id'(newId){
      if(newId == 1||newId == 2){
        this.fm.jurusan_id = null;
      }      
      if(newId == 1){
        this.fm.sekolah_internal = null;        
      } else {
        if(this.fm.sekolah_internal){
          if(this.fm.tingkat_id == 2){
            this.fm.sekolah_nama = 'SD QUR-AN ARRISALAH';
            this.fm.sekolah_npsn = '69830211';
          } else if(this.fm.tingkat_id == 3){
            if(this.fm.gender == 1){
              this.fm.sekolah_nama = 'SMP PERGURUAN ISLAM AR RISALAH';
              this.fm.sekolah_npsn = '10310320';
            } else {
              this.fm.sekolah_nama = 'SMP PUTRI PERGURUAN ISLAM AR-RISALAH';
              this.fm.sekolah_npsn = '70000691';
            }        
          }       
          this.fm.sekolah_provinsi_id = 13;
          this.fm.sekolah_kota_id = 1371;       
          this.fm.sekolah_kecamatan_id = 1371110;       
        }    
      }
      
    },
    'fm.sekolah_internal'(newBool, oldBool){
      if(oldBool){
        this.fm.sekolah_nama = null;
        this.fm.sekolah_npsn = null;
        this.fm.sekolah_provinsi_id = null;
        this.fm.sekolah_kota_id = null;       
        this.fm.sekolah_kecamatan_id = null; 
      }
      if(newBool){
        if(this.fm.tingkat_id == 1){
          this.fm.sekolah_nama = 'TK RA ARRISALAH';          
        } else if(this.fm.tingkat_id == 2){
          this.fm.sekolah_nama = 'SD QUR-AN ARRISALAH';
          this.fm.sekolah_npsn = '69830211';
        } else if(this.fm.tingkat_id == 3){
          if(this.fm.gender == 1){
            this.fm.sekolah_nama = 'SMP PERGURUAN ISLAM AR RISALAH';
            this.fm.sekolah_npsn = '10310320';
          } else {
            this.fm.sekolah_nama = 'SMP PUTRI PERGURUAN ISLAM AR-RISALAH';
            this.fm.sekolah_npsn = '70000691';
          }                  
        }           
        this.fm.sekolah_provinsi_id = 13;
        this.fm.sekolah_kota_id = 1371;       
        this.fm.sekolah_kecamatan_id = 1371110;   
      }      
    },
    'fm.gender'(){
      /*this.fm.sekolah_nama = null;
      this.fm.sekolah_npsn = null;
      this.fm.sekolah_provinsi_id = null;
      this.fm.sekolah_kota_id = null;       
      this.fm.sekolah_kecamatan_id = null; */
      this.sekolahInternalLabel()
      if(this.fm.sekolah_internal){
        if(this.fm.tingkat_id == 2){
          this.fm.sekolah_nama = 'SD QUR-AN ARRISALAH';
          this.fm.sekolah_npsn = '69830211';
        } else if(this.fm.tingkat_id == 3){
          if(this.fm.gender == 1){
            this.fm.sekolah_nama = 'SMP PERGURUAN ISLAM AR RISALAH';
            this.fm.sekolah_npsn = '10310320';
          } else {
            this.fm.sekolah_nama = 'SMP PUTRI PERGURUAN ISLAM AR-RISALAH';
            this.fm.sekolah_npsn = '70000691';
          }                  
        }          
        this.fm.sekolah_provinsi_id = 13;
        this.fm.sekolah_kota_id = 1371;       
        this.fm.sekolah_kecamatan_id = 1371110;    
      }      
    },   
    'fm.provinsi_id'(id){
      this.kotaLoading = true;
      model.kotas({'KotaSearch[provinsi_id]':id}).then(data=>{this.kotas = data; this.kotaLoading = false;});
    },
    'fm.sekolah_provinsi_id'(id){
      this.sekolahKotaLoading = true;
      model.kotas({'KotaSearch[provinsi_id]':id}).then(data=>{this.sekolahKotas = data; this.sekolahKotaLoading = false;});
    }, 
    'fm.kota_id'(id){
      this.kecamatanLoading = true;
      model.kecamatans({'KecamatanSearch[kota_id]':id}).then(data=>{this.kecamatans = data; this.kecamatanLoading = false;});
    },
    'fm.sekolah_kota_id'(id){
      this.sekolahKecamatanLoading = true;
      model.kecamatans({'KecamatanSearch[kota_id]':id}).then(data=>{this.sekolahKecamatans = data; this.sekolahKecamatanLoading = false;});
    },
    'fm.kecamatan_id'(id){
      this.kelurahanLoading = true;
      model.kelurahans({'KelurahanSearch[kecamatan_id]':id}).then(data=>{this.kelurahans = data; this.kelurahanLoading = false;});
    },
    tingkat_id(nVal){
      this.fm.tingkat_id = nVal
      this.sekolahInternalLabel()
    },
    jalur_id(nVal){
      this.fm.jalur_id = nVal           
    },
    voucher(nVal){
      this.fm.voucher  = nVal           
    },
  },     
  mounted(){
    model.settings({key:'dapodik'}).then(data=>{
      if(Array.isArray(data.value)){
        data.value.forEach(item=>{
          if(item.name == 'pekerjaans'){
            this.pekerjaans = item.childs;
          }
          if(item.name == 'penghasilans'){
            this.penghasilans = item.childs;
          }
        })
      }      
    });    
    /*this.$watch(['fm','lahir_tanggal'].join('.'), (val)=>{ if(val){
      this.$refs.birthdate.save(val);
      this.fm.lahir_tanggalV = this.$moment(val).format('DD-MM-YYYY');
    }});*/
    this.fm.user_id = this.user.id; this.fm.telepon = this.user.phone;
    this.getavatar(); this.init(); 
  },
  methods:{
    init(){
      model.viewAdministrasi({id:this.user.id}).then(data=>{        
        Object.assign(this.fm, data);
        if(Array.isArray(this.fm.calonPrestasis)){
          this.fm.calonPrestasis.forEach((item)=>{
            item.thumb = this.imageUrl('certificate-thumb', item.id);
            item.image = this.imageUrl('certificate-image', item.id);
          });
        }                
      });      
      this.setProvinsis();
      /*this.$watch(['fm','provinsi_id'].join('.'), (id)=>{this.kotaLoading = true;
        model.kotas({'KotaSearch[provinsi_id]':id}).then(data=>{this.kotas = data; this.kotaLoading = false;});
      });
      this.$watch(['fm','sekolah_provinsi_id'].join('.'), (id)=>{this.sekolahKotaLoading = true;
        model.kotas({'KotaSearch[provinsi_id]':id}).then(data=>{this.sekolahKotas = data; this.sekolahKotaLoading = false;});
      });
      this.$watch(['fm','kota_id'].join('.'), (id)=>{this.kecamatanLoading = true;
        model.kecamatans({'KecamatanSearch[kota_id]':id}).then(data=>{this.kecamatans = data; this.kecamatanLoading = false;});
      });
      this.$watch(['fm','sekolah_kota_id'].join('.'), (id)=>{this.sekolahKecamatanLoading = true;
        model.kecamatans({'KecamatanSearch[kota_id]':id}).then(data=>{this.sekolahKecamatans = data; this.sekolahKecamatanLoading = false;});
      });
      this.$watch(['fm','kecamatan_id'].join('.'), (id)=>{this.kelurahanLoading = true;
        model.kelurahans({'KelurahanSearch[kecamatan_id]':id}).then(data=>{this.kelurahans = data; this.kelurahanLoading = false;});
      });*/
    },
    
    setFile(event, props){      
      props.item.file = event.target.files[0];
    },
    
    imageUrl(route, id){ return this.$config.file + route +'?reff_id='+id+'&'+(0|Math.random()*9e6).toString(36);},

    newPrestasi(){
      this.fm.calonPrestasis.push({type : null, description: null, file:null});
    },
    
    delPrestasi(props){            
      this.fm.calonPrestasis.splice(props.index, 1);   
      //this.detail.splice(props.index, 1);   
    },
    
    setProvinsis(){
      this.provinsiLoading = true; this.sekolahProvinsiLoading = true;
      model.provinsis().then(data=>{
        this.provinsis = data; this.sekolahProvinsis = data;
        this.provinsiLoading = false; this.sekolahProvinsiLoading = false;
      });
    },

    sekolahInternalLabel(){      
      if(this.fm.tingkat_id == 1){
        this.internal_label = 'Centang jika ananda berasal dari RA Arrisalah';
      } else if(this.fm.tingkat_id == 2){
        this.internal_label = 'Centang jika ananda berasal dari SDQU Arrisalah';
      } else if(this.fm.tingkat_id == 3){
        if(this.fm.gender == 1){
          this.internal_label = 'Centang jika ananda berasal dari SMP PA Arrisalah';
        } else {
          this.internal_label = 'Centang jika ananda berasal dari SMP PI Arrisalah';
        }        
      }      
    },
    
    getColor(tingkat){
      switch(tingkat){case 1:return 'red darken-2'; case 2: return 'indigo'; case 3:return 'blue-grey'; default:return 'black';}
    },

    getTingkat(tingkat){
      switch(tingkat){case 1:return 'SD'; case 2: return 'SMP'; case 3:return 'MA'; default:return 'FORM';}
    },
    
    customFilter (item, queryText, itemText) {
      const textOne = item.nama.toLowerCase()
      //const textTwo = item.abbr.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1; 
    }, 
    
    saveAdministrasi(){
      this.saveLoading=true;
      this.prestasiError = '';
      var FormData = require('form-data');        
      let fmdata   = new FormData();
      let formData = this.convertToFormData(this.fm, fmdata, null);
      model.saveAdministrasi(formData).then(res=>{
        if(res.status === 200){  
            this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
            //this.$router.push({path:'/user', query:{id:res.data.id}});                    
        } else {
            var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
            var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
            if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
            this.$swal({type: 'error', title: title, text: text});                    
        }
        this.saveLoading=false;
      });                        
    },
    
    completeAdministrasi(){
      this.prestasiError = '';
      this.$validator.validateAll();
      if(this.fm.jalur_id== 2 && !this.fm.calonPrestasis.length){
        this.prestasiError = 'Silahkan input data prestasi ananda terlebih dahulu.';
        this.$swal({type: 'error', title: 'Data Validation', text: this.prestasiError}); 
        return;        
      }
      if( !this.errors.any() ) { 
        this.$swal({
            title: "Konfirmasi",
            text: "Apakah ananda yakin data yang diinputkan sudah benar?",
            type: "info",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ya, saya yakin"
        }).then((result) => { // <--
            if (result.value) { // <-- if confirmed
              this.completeLoading=true;
              var FormData = require('form-data');        
              let fmdata   = new FormData();
              let formData = this.convertToFormData(this.fm, fmdata, null);
              model.completeAdministrasi(formData).then(res=>{
                if(res.status === 200){  
                    this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
                    if(res.data.jalur_id==4){
                      this.$emit('update:stepke', 4)
                    } else {
                      this.$emit('update:stepke', 3)
                    }
                    
                    //this.$router.push({path:'/user', query:{id:res.data.id}});                    
                } else {
                    var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                    var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
                    if(res.data){ if(res.data.message){ text = ' ' + res.data.message; } else {this.validate(res.data);}}                
                    this.$swal({type: 'error', title: title, text: text});                    
                }
                this.completeLoading=false;
              });     
            }
        });             
      } else {
        this.$swal({type: 'error', title: 'Data Belum Lengkap', text: 'Silahkan lengkapi data ananda terlebih dahulu'}); 
      }        
    },
    
    validate(data){
      data.forEach( (item) => {
        this.$validator.errors.add({field : item.field,msg : item.message});
      });
    }, 
    
    convertToFormData(data, formData, parentKey) {
        if(data === null || data === undefined) return null;
        formData = formData || new FormData();
        if (typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
          Object.keys(data).forEach(key => 
            //this.convertToFormData(data[key], formData, (!parentKey ? key : (data[key] instanceof File ? parentKey : `${parentKey}[${key}]`)))
            this.convertToFormData(data[key], formData, (!parentKey ? key : (data[key] instanceof File ? `${parentKey}[${key}]` : `${parentKey}[${key}]`)))
          );
        } else {
          formData.append(parentKey, data);
        }
        return formData;
    },
    
    cropSuccess(imgDataUrl, field){
      //console.log('-------- crop success --------');
      //this.imgDataUrl = imgDataUrl;

      var block = imgDataUrl.split(";");
      var contentType = block[0].split(":")[1];// In this case "image/gif"
      var realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."
      var blob = this.b64toBlob(realData, contentType);

      var FormData = require('form-data');
      let formData = new FormData();

      formData.append('image', blob, 'userprofile');
      formData.append('reff_id', this.user.id);
      formData.append('reff_type', 1);        

      this.imgLoading = true;
      model.setavatar(formData).then(res=>{
        this.getavatar();            
      });
    }, 
    
    getavatar(){
      this.imgLoading  = true;
      model.getavatar({reff_id:this.user.id}).then(res=>{
        if(res.data){
          this.imgUrl      = res.data;          
        }
        this.imgLoading  = false;
      });
    },
    
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },
  }
};
</script>
<style>
.vue-image-crop-upload .vicp-wrap{      
  height: 85%;
  width : 80%;
  min-height:330px;
  max-width: 600px;
}
</style>


